import manifest from "./manifest.js";

const aliases = {
  [manifest.SABLIER_LOCKUP]: "LK",
};

export default aliases;
